export const BRANDS_FILTER_MODAL_SHOW_SET = 'PortfolioPageHeader/brands-filter-modal-show-set';
export const CHANGES_APPLY = 'PortfolioPageHeader/changes-apply';
export const MODAL_OPEN = 'PortfolioPageHeader/modal-open';
export const PORTFOLIO_BRANDS_INITIALIZE = 'PortfolioPageHeader/portfolio-brands-initialize';
export const SELECTED_BRANDS_SET = 'PortfolioPageHeader/selected-brands-set';
export const SELECTED_TRANSIENT_BRANDS_SET = 'PortfolioPageHeader/selected-transient-brands-set';
export const BRAND_PICKER_MODAL_OPEN = 'PortfolioPageHeader/brand-picker-modal-open';
export const BRANDS_PICKER_MODAL_SHOW_SET = 'PortfolioPageHeader/brands-picker-modal-show-set';
